class MFRCoreCardText {
    constructor(i, e) {
        this.$index = i;
        this.$element = $(e);

        this.selectors = {
            readMoreBtnSelector: "read-more-btn"
        };

        this.init();
    }

    init() {
        this.toggleDescription();
    }

    toggleDescription() {
        const $btn = this.$element.find(".read-more-btn");
        const $descShort = $btn.siblings(".desc-short");
        const $descFull = $btn.siblings(".desc-full");

        if ($descShort.text() == $descFull.text()) {
            $btn.hide();
        }
        else {
            $btn.show();
        }

        $btn.on('click', function () {
            const $this = $(this);
            const $descShort = $this.siblings(".desc-short");
            const $descFull = $this.siblings(".desc-full");
            $descShort.toggle();
            $descFull.toggle();
            $this.text($this.text() === 'Read More' ? 'Read Less' : 'Read More');
        });
    }
}